import { FEATURE_FLAGS } from "constants/flags";
import { VersionControl } from "types/payments/Checkout";
import { useVariant } from "@unleash/proxy-client-react";

type UseVersionControlResult = {
  upgrade: VersionControl | null;
  purchase: VersionControl | null;
  subscription_upgrade: VersionControl | null;
};

export const useVersionControl = (): UseVersionControlResult => {
  const upgrade = (useVariant(FEATURE_FLAGS.upgradeVersionControl).payload
    ?.value ?? null) as VersionControl | null;
  const purchase = (useVariant(FEATURE_FLAGS.purchaseVersionControl).payload
    ?.value ?? null) as VersionControl | null;
  const subscriptionUpgrade = (useVariant(
    FEATURE_FLAGS.subscriptionUpgradeVersionControl,
  ).payload?.value ?? null) as VersionControl | null;
  return {
    upgrade,
    purchase,
    subscription_upgrade: subscriptionUpgrade,
  };
};
